module.exports = __webpack_public_path__ + "static/media/golf-carousel-2-360x640.6232706d.jpg";